import { FormSections, ProgramContainer } from "../entities/formTemplateDataType";

export default class SectionUtils {

    static getElementByFieldName(fieldName: string, formSection: FormSections) {
        const root = formSection.parent;   
        const formList =root.ListOfFormSections;
        formList.forEach(section=>{
            section.forEach(sub=>{
                const elements = sub.ListOfFormSectionElements;
                elements.forEach(ele=>{
                    if(ele.LoadBindName==fieldName)
                        return ele;
                })
            })
        });
    
        return null;
    };

    static getFieldsAboveTitle(formSection: FormSections) {
        let list = [];
        const subformList = formSection?.ListOfFormSubSections;
        if(subformList){
             subformList.forEach(sub => {
            const fields = sub.ListOfFormSectionElements.filter(ele => ele.FieldMustBeAtTop);
            if (fields.length > 0) {
                list.push(...fields);
            }
        });      
        }
 

        return list;
    };

    static HasCustimzedSummary(programContainer: ProgramContainer) {
        const formList =programContainer.ListOfFormSections;
        const forms=formList.filter(p=>p.CustomizedReviewPage);
        const customized = forms.length>0
        return customized;
    };

    static GetTechErrorSectionIndex(programContainer: ProgramContainer): number{
        const formList =programContainer.ListOfFormSections;
        const forms=formList.filter(p=>p.IsTechErrorPage);
        const techErrorSection= forms[0];
        const techErrorSectionIndex = formList.findIndex(p => p === techErrorSection);
        return techErrorSectionIndex;
    }
}
